<template>
    <template v-if="stock && stock.final_price">
        <div class="single-product__price-box__divider"></div>
        <div class="single-product__price-box__item single-product__price-box__price-item">
            <span class="single-product__price-box__text">قیمت:</span>
            <div class="single-product__price-box__price single-product__price-box__price--off">
                <div v-if="stock.discount" class="single-product__price-box__original-price">
                    <span class="single-product__price-box__money-figure">{{numberFormat(stock.regular_price)}}</span>
                    <span class="single-product__price-box__badge badge rounded-pill">%{{stock.discount_percentage}}</span>
                </div>
                <div class="single-product__price-box__off-price">
                    <span class="single-product__price-box__money-figure">{{numberFormat(stock.final_price)}}</span>
                    <span class="single-product__price-box__monetary-unit">تومان</span>
                </div>
            </div>
        </div>
    </template>
</template>

<script>
import {ProductMixin} from "./ProductMixin";

export default {
    name: "SingleProductPrice",
    mixins: [ProductMixin],
}
</script>

<style scoped>

</style>
